import React from 'react';
import { UBTracking } from '../../../components/tracking/ubtracking.ts';

type SocialMediaLogoProps = { variant: 'white' | 'red'; className?: string };

export const FacebookLogo: React.FunctionComponent<SocialMediaLogoProps> = props => {
  return (
    <a
      href="https://www.facebook.com/speisekarte.de"
      target="_blank"
      className={props.className}
      onClick={() => UBTracking.trackEvent.click('restaurant_info_modal', 'SOCIAL_MEDIA::FACEBOOK')}
    >
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.5249 26V17.25H21.2873L21.9144 13.5H17.5249V11.625C17.5249 10.375 18.1532 9.75 19.4061 9.75H21.2873V6H18.1519C15.0166 6 13.7624 7.875 13.7624 11V13.5H10V17.25H13.7624V26H17.5249Z"
          fill={props.variant === 'white' ? 'white' : 'var(--color-sk-red-500)'}
        />
      </svg>
    </a>
  );
};

export const InstagramLogo: React.FunctionComponent<SocialMediaLogoProps> = props => {
  return (
    <a
      href="https://www.instagram.com/speisekarte.de/"
      target="_blank"
      className={props.className}
      onClick={() =>
        UBTracking.trackEvent.click('restaurant_info_modal', 'SOCIAL_MEDIA::INSTAGRAM')
      }
    >
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.9968 6C13.2819 6 12.9414 6.01149 11.8752 6.06004C10.8111 6.10848 10.0844 6.27715 9.44849 6.5238C8.79115 6.77873 8.23361 7.11988 7.67786 7.67453C7.12206 8.22923 6.78028 8.78562 6.5248 9.44166C6.27766 10.0763 6.10869 10.8015 6.06012 11.8635C6.01147 12.9277 6 13.2674 6 15.977C6 18.6867 6.01147 19.0264 6.06012 20.0906C6.10869 21.1525 6.27766 21.8778 6.5248 22.5124C6.78028 23.1684 7.12206 23.7249 7.67786 24.2795C8.23361 24.8342 8.79115 25.1753 9.44849 25.4303C10.0844 25.677 10.8111 25.8456 11.8752 25.8941C12.9414 25.9426 13.2819 25.9541 15.9968 25.9541C18.7118 25.9541 19.0522 25.9426 20.1185 25.8941C21.1826 25.8456 21.9092 25.677 22.5452 25.4303C23.2025 25.1753 23.76 24.8342 24.3158 24.2795C24.8716 23.7249 25.2134 23.1685 25.4688 22.5124C25.716 21.8778 25.885 21.1525 25.9335 20.0906C25.9822 19.0264 25.9937 18.6867 25.9937 15.977C25.9937 13.2674 25.9822 12.9277 25.9335 11.8635C25.885 10.8015 25.716 10.0763 25.4688 9.44166C25.2134 8.78562 24.8716 8.22923 24.3158 7.67453C23.76 7.11988 23.2025 6.77873 22.5452 6.5238C21.9092 6.27715 21.1826 6.10848 20.1185 6.06004C19.0522 6.01149 18.7118 6 15.9968 6ZM15.9968 7.79767C18.6661 7.79767 18.9823 7.80781 20.0364 7.85581C21.0111 7.9002 21.5404 8.06274 21.8927 8.19937C22.3593 8.38036 22.6923 8.59656 23.0421 8.94567C23.3919 9.29482 23.6086 9.62717 23.79 10.0929C23.9268 10.4444 24.0897 10.9727 24.1342 11.9455C24.1822 12.9975 24.1924 13.3131 24.1924 15.977C24.1924 18.641 24.1822 18.9566 24.1342 20.0086C24.0897 20.9814 23.9268 21.5097 23.79 21.8612C23.6086 22.3269 23.3919 22.6593 23.0421 23.0084C22.6923 23.3575 22.3593 23.5737 21.8927 23.7547C21.5404 23.8913 21.0111 24.0539 20.0364 24.0983C18.9824 24.1463 18.6663 24.1564 15.9968 24.1564C13.3273 24.1564 13.0112 24.1463 11.9573 24.0983C10.9826 24.0539 10.4532 23.8913 10.101 23.7547C9.63437 23.5737 9.30131 23.3575 8.95151 23.0084C8.60171 22.6593 8.38504 22.3269 8.20369 21.8612C8.06683 21.5097 7.90397 20.9814 7.85948 20.0086C7.81139 18.9566 7.80123 18.641 7.80123 15.977C7.80123 13.3131 7.81139 12.9975 7.85948 11.9455C7.90397 10.9727 8.06683 10.4444 8.20369 10.0929C8.38504 9.62717 8.60171 9.29482 8.95151 8.94571C9.30131 8.59656 9.63437 8.38036 10.101 8.19937C10.4532 8.06274 10.9826 7.9002 11.9572 7.85581C13.0114 7.80781 13.3275 7.79767 15.9968 7.79767Z"
          fill={props.variant === 'white' ? 'white' : 'var(--color-sk-red-500)'}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.9968 19.3028C14.1565 19.3028 12.6645 17.8138 12.6645 15.9771C12.6645 14.1404 14.1565 12.6514 15.9968 12.6514C17.8372 12.6514 19.3291 14.1404 19.3291 15.9771C19.3291 17.8138 17.8372 19.3028 15.9968 19.3028ZM15.9968 10.8538C13.1617 10.8538 10.8633 13.1475 10.8633 15.9771C10.8633 18.8067 13.1617 21.1005 15.9968 21.1005C18.832 21.1005 21.1303 18.8067 21.1303 15.9771C21.1303 13.1475 18.832 10.8538 15.9968 10.8538Z"
          fill={props.variant === 'white' ? 'white' : 'var(--color-sk-red-500)'}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M22.5328 10.6513C22.5328 11.3126 21.9957 11.8486 21.3332 11.8486C20.6706 11.8486 20.1335 11.3126 20.1335 10.6513C20.1335 9.9901 20.6706 9.4541 21.3332 9.4541C21.9957 9.4541 22.5328 9.9901 22.5328 10.6513Z"
          fill={props.variant === 'white' ? 'white' : 'var(--color-sk-red-500)'}
        />
      </svg>
    </a>
  );
};
